import { useState } from "react";
import "../../Pages/Styles/common-styles.css"

const LikeButton = ({ context = "" }) => {
  const [likes, setLikes] = useState(0);

  const className = context === "userProfile" ? "up-text-label" : "text-label";

  return (
    <span
      onClick={() => setLikes(likes + 1)}
      className={className}
      style={{fontStyle: 18, fontWeight: "normal"}}
    >
      👍
    </span>
  );
};

export default LikeButton;
